import "./success-stories.css"
import image from "./TestImage.jpg"
import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import GridList from "@material-ui/core/GridList"
import GridListTile from "@material-ui/core/GridListTile"
import GridListTileBar from "@material-ui/core/GridListTileBar"
import ListSubheader from "@material-ui/core/ListSubheader"
import IconButton from "@material-ui/core/IconButton"
import tileData from "./catalog"
import background from "./background.png"
import { Card, CardActions, CardContent, Grid, Typography } from "@mui/material"

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper,
  },
  gridList: {
    width: "70%",
    height: "auto",
    justify: "center",
  },
  image: {
    borderRadius: "25px",
    height: "20%",
    width: "50%",
  },
  button: {
    color: "white",
    height: 300,
    width: "100%",
    borderColor: "white",
    borderRadius: "25px",
  },
  smallerText: {},
}))

/* function StoryItem(props: { sourceName: string | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined; name: string | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined; storyTitle: string | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined; handleClick: React.MouseEventHandler<HTMLImageElement> | undefined; }) {
  const classes = useStyles();
  return (
      <GridListTile item xs={6}>
        <Paper className = {classes.paper}>
          <button><img src = {image} alt ={"Image"} onClick={props.handleClick}/></button>
          <h2>{props.name}</h2>
          <h3>{props.storyTitle}</h3>
        </Paper>
      </Grid>
    </div>
  )
}


function Stories() {
    const classes = useStyles();

    const catalogItems = catalog.map((item: { name: any; storyTitle: any; sourceName:any; }) => {
        return (
        <StoryItem
            name={item.name}
            storyTitle={item.storyTitle}
            sourceName = {item.sourceName}
            handleClick={
            () => {
                alert("Hello World! Redirect here")
            }
            }
        />
        )
    });


    return (
      <Grid container spacing={2} className={classes.grid}>
        {catalogItems}
      </Grid> 

        /* <div className="container">
            <div className="items">
                {catalogItems}
            </div>
        </div> 
    );
} */

export default function Stories() {
  return (
    <Grid
      container
      sx={{
        width: "90%",
        margin: "auto",
        marginTop: "120px",
      }}
    >
      <h3 className="h3">Success Stories</h3>
      <Grid item xs={12}>
        <Card
          sx={{
            margin: "auto",
            width: "70%",
            padding: "20px",
            borderRadius: "20px",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
            boxShadow: "0px 0px 60px rgba(149, 163, 127, 0.8)",
            marginBottom: "120px",
          }}
        >
          <CardContent sx={{}}>
            <Typography
              variant="body1"
              sx={{ margin: "10px", fontSize: "20px", fontFamily: "DM Sans" }}
            >
              Expungement success stories develop over time and may be
              short-term, intermediate, or long term in their development.
              <br></br>
              <br></br>
              Our three-tier program captures each individual through their
              education, use of resources, and collaboration. Since our program
              is in its early stages, our anticipated outcomes highlight our
              partnerships that create, document, and achieve results.<br></br>
              <br></br>
              Please check back for some good stories that our participants are
              willing to share. <br></br>
              <br></br>Our program successes include professional development,
              collaboration and capacity building, and personal guidance. Please
              check back as all our stories are a “work in progress”. We will
              update and enhance our stories as new information and outcome data
              become available.
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  )
}
